import type { LoginStatus } from "../types";

export const FULLY_LOADED = "FULLY LOADED";

export const PAGE_TAG_1 = "tag-1";
export const PAGE_TAG_2 = "tag-2";
export const PAGE_TAG_3 = "tag-3";
export const PAGE_TAG_7 = "tag-7";
export const PAGE_TAG_8 = "tag-8";

export const COMPONENT_LOAD_EVENT_TYPE = "load";
export const COMPONENT_LOAD_CLICK_TYPE = "component_load";

export const ANALYTICS_DEBUG_KEY = "__BFL_ANALYTICS_DEBUG__";
export const ANALYTICS_E2E_PAGE_LOAD_TIME_SECONDS_KEY = "__BFL_E2E_PAGE_LOAD_TIME_SECONDS__";
export const ANALYTICS_DEBUG_DEFAULT_CONFIG = { console: false, fireEvents: true } as const;

export const TRACKING_POST_LOAD_QUIET_PERIOD_MS = 800;
export const TRACKING_MAX_WAIT_AFTER_WINDOW_LOAD_MS = 60000;
export const TRACKING_FETCH_WRAPPED_GLOBAL_FLAG = "__bflInitialLoadFetchWrapped";
export const TRACKING_AXIOS_TOKEN_KEY = "__bflInitialLoadTrackingToken";

export const GA_LOGIN_STATE_TEXT: Record<LoginStatus, string> = {
  success: "Identified",
  failure: "Non Loggedin",
  pending: "Non Loggedin",
  perpetual: "Perpetual",
};

export const componenConstants = {
  CALCULATOR: "calculator",
  H1_COMPONENT: "h1Component",
  DISCLAIMER: "disclaimer",
  INTERACTIVE_DISCLAIMER: "interactiveDisclaimer",
  LOAN_APPLICATION_GUIDE: "loanApplicationGuide",
  KEY_FEATURES: "content_cards_information_descriptive_content_list",
  KNOW_YOUR_VEHICLE: "knowYourVehicle",
  PRE_APPROVED_CARD_FORM: "pre_approved_card_form",
  FEES_AND_CHARGES_COMPONENT: "fees_and_charges_accordion",
  FEES_AND_CHARGES_ARROW_CTA: "accordion_arrow_icon",
  FEES_AND_CHARGES_ARROW_ELEMENT: "fees_and_charges_accordion_click",
  DOCKED_SIGN_IN_STRIP: "docked_sign_in_strip",
} as const;

export const elementConstants = {
  TENURE: "tenure_click",
  LOAN_VARIANT: "loanVariant_click",
  LOAN_SUMMARY: "loanSummary_click",
  INPUT_AMOUNT: "inputAmount_click",
  KEY_FEATURES_CLICK: "content_cards_information_descriptive_content_list_icon_click",
  ERROR_VALIDATION_TEXT: "Error in validation",
  CALCULATOR_TOOLTIP_OPEN: "calculator_tooltip_open_click",
  CALCULATOR_TOOLTIP_CROSS: "calculator_tooltip_cross_click",
  CALCULATOR_TOOLTIP_TAB: "calculator_tooltip_tab_click",
  CALCULATOR_TOOLTIP_CLOSE: "calculator_tooltip_close_click",
  PRE_APPROVED_CARD_RADIO_CLICK: "pre_approved_card_radio_click",
  PRE_APPROVED_CARD_BUTTON_CLICK: "pre_approved_card_button_click",
} as const;

export const eventConstants = {
  CLICK: "click",
  LOAD: "load",
  BUTTON_CLICK: "button_click",
  PROGRESS_BAR_CLICK: "progress_bar_click",
  INPUT_TEXT: "input_text",
  LINK_CLICK: "link_click",
  CALCULATOR_TEXT_BOX_CLICK: "calculator_text_box_click",
  CALCULATOR_TAB_CLICK: "calculator_tab_click",
  CALCULATOR_BUTTON_CLICK: "calculator_button_click",
  CALCULATOR_ICON_CLICK: "calculator_icon_click",
  ICON_CLICK: "icon_click",
} as const;

export const ctaTextConstants = {
  INPUT_TEXT: "input_text",
  TOOLTIP_ICON_CLICK: "info_icon_click",
  TOOLTIP_MODAL_CLOSE: "modal_close",
} as const;
